import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Hidden } from "@material-ui/core";
import Image from '../components/image';
import Header from "./header";

const Content = ({ children, data, navNumber }) => {
  return (
    <div>
      <Header siteTitle={data.site.siteMetadata.title} navNumber={navNumber} />
      <Image
        name="bg"
        style={{
          position: "fixed",
          bottom: 0,
          right: 0,
          padding: 0,
          margin: 0,
          zIndex: 99999,
          width: typeof window !== 'undefined' ? (window.innerWidth <= 960 ? 33.33 : 100) : 0,
          transform: 'rotateY(-180deg)',
        }}
      />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={9} lg={10} xl={9}>
            <main>{children}</main>
          </Grid>
          <Hidden implementation="css" smDown>
            <Grid item md={3} lg={2} xl={1}>
            </Grid>
          </Hidden>
        </Grid>
        {/* <Hidden implementation="css" mdUp>
          <main>{children}</main>
        </Hidden> */}
        <footer>
          © {new Date().getFullYear()}, All rights resevered -
            {` `}
          <a href="https://alireza-kavian.github.io">Alireza Kavian</a>
        </footer>
      </div>
    </div>
  );
}


Content.propTypes = {
  children: PropTypes.array.isRequired,
  data: PropTypes.shape().isRequired,
  navNumber: PropTypes.number.isRequired
}

export default Content

